// Productcall.js
import { useEffect, useState } from 'react';
import axios from 'axios';
import { productsURL, budgetProductURL, premiumProductURL, midRangeProductURL } from '../components/assets/constants/Urls/Url';

const Products = (level = null) => {
  const [productData, setProductData] = useState([]); // state to hold product data
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0); // current page for pagination
  const [hasMore, setHasMore] = useState(true); // flag to check if more data is available
  const limit = 10; // Number of items per request

  console.log("level from product call: ",level)
  const fetchProducts = async () => {
    if (isLoading || !hasMore) return;

    setIsLoading(true);
    try {

      let collectionURL = productsURL
      if (level) {
        switch(level){
          case 'budget-class': 
            collectionURL = budgetProductURL;
            break;
          case 'mid-class':
            collectionURL = midRangeProductURL;
            break;
          case 'premium-class':
            collectionURL = premiumProductURL;
            break;
          default:
            collectionURL = productsURL
        }
      }
      
      const response = await axios.get(`${collectionURL}?limit=${limit}&offset=${page * limit}`);
      const newProducts = response.data;
      console.log('response: ', response); // Log the response data for debugging
      if (newProducts.length > 0) {
        setProductData((prev) => [...prev, ...newProducts]); // append new data
        setPage((prev) => prev + 1); // increment page
      } else {
        setHasMore(false); // no more products
      }
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    } 
  };


  useEffect(() => {
    fetchProducts(); // Initial fetch
  }, []);

  return { productData, error, isLoading, fetchProducts, hasMore };

};

export default Products;



